import { FC } from 'react';
import { useRosterHistory } from '../hooks/useRosterHistory';
import { RosterHistoryRow } from './RosterHistoryRow';
import { TActivityHistory } from '../../../../../shared/types/activitiesTypes';
import { t } from 'i18next';
import { ComplexTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';
import cx from 'classnames';

type TRosterHistoryTableProps = {
  group: any;
  type?: string;
  className?: string;
};

const SidebarContent: FC<any> = (props) => {
  const { history, scopeDays } = props;

  return (
    <section className={cx(props.className, 'rio-sidebar-section fade-in--fast')}>
      <div className="rio-sidebar-header slds-text-heading--small slds-text-title--caps text-white slds-text-align--center">
        <span className="new-feature-indicator text-uppercase slds-m-right--small">{t('nav:suffixes.beta')}</span>
        {t('settings:group-privacy.history-table-title')}{' '}
        <ComplexTooltip
          placement="top"
          tooltip={`Roster history showing the previous ${scopeDays} days of roster changes.`}
          tag="span"
        >
          <i className="fa fa-circle-info slds-m-left--xx-small slds-text-body--small" />
        </ComplexTooltip>
      </div>
      <div className={`${props.className || ''} slds-scrollable--y`} style={{ maxHeight: '16rem' }}>
        <table className="rio-rankings-table slds-table slds-no-row-hover">
          <tbody>
            {history.map((item: TActivityHistory, index: number) => (
              <RosterHistoryRow key={index} {...item} />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

const FullContent: FC<any> = (props) => {
  const { history, scopeDays } = props;
  return (
    <section className={`rio-guild-rankings-table ${props.className || ''} slds-scrollable--x slds-m-top--small`}>
      <table className="slds-table slds-no-row-hover rio-guild-details-table">
        <thead>
          <tr>
            <td colSpan={3} className="slds-text-align--center slds-text-title--bold text-uppercase">
              <div className="slds-grid slds-grid--align-center">
                <span className="new-feature-indicator text-uppercase slds-m-right--small">
                  {t('nav:suffixes.beta')}
                </span>
                {t('settings:group-privacy.history-table-title')}{' '}
                <ComplexTooltip
                  placement="top"
                  tooltip={t('settings:group-privacy.history-table-title-tooltip', { days: scopeDays })}
                >
                  <i className="fa fa-circle-info slds-m-left--x-small slds-text-body--small" />
                </ComplexTooltip>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {history.map((item: TActivityHistory, index: number) => (
            <RosterHistoryRow key={index} {...item} />
          ))}
        </tbody>
      </table>
    </section>
  );
};

export const RosterHistoryTable = (props: TRosterHistoryTableProps) => {
  const { isLoading, history, isLoaded, scopeDays } = useRosterHistory(props.group.id);

  if (isLoading || !isLoaded || !history.length) {
    return <></>;
  }

  if (props.type === 'sidebar') {
    return (
      <SidebarContent {...props} isLoading={isLoading} isLoaded={isLoaded} history={history} scopeDays={scopeDays} />
    );
  }
  return <FullContent {...props} history={history} scopeDays={scopeDays} />;
};
